import { useCallback } from 'react';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

import { prepareOptionSiteValues } from '@utils/kpi-utils/common';
import { changeOptionsByVendor } from '@components/Kpi/Parameters/utils';

import { IKPISite, TResetSitesAndVendorArgs } from '@interfaces/kpi/kpiCommon';
import { IGroupSelectOptions, TOnChangeSites } from '@components/common/GroupSelect/GroupSelect.types';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { ETechnologiesValues, TVendorsValues } from '@enums/common';
import { EFormFields } from '@enums/kpi-api';

interface UsePresetSitesAndVendorLogicProps {
	setValue: UseFormSetValue<FieldValues>;
	optionsVendorsKpi: Array<TSelectOptionType & { isDefault: boolean }>;
	onChangeSitesT_5G: (...params: TOnChangeSites) => void;
	resetT_5G: () => void;
	options5GOran: Array<IGroupSelectOptions>;
	vendor: { name?: TVendorsValues; value: TVendorsValues };
}

export const usePresetSitesAndVendorLogic = ({
	setValue,
	optionsVendorsKpi,
	onChangeSitesT_5G,
	resetT_5G,
	options5GOran,
	vendor,
}: UsePresetSitesAndVendorLogicProps) => {
	const resetSitesAndVendor = useCallback((...params: TResetSitesAndVendorArgs) => {
		const [selectedValues, isUpdateDirty = true] = params;

		const options5G = changeOptionsByVendor({
			vendor: { value: selectedValues.vendor },
			options5GOran,
		});

		if (selectedValues.vendor !== vendor?.value) {
			setValue(EFormFields.vendor, optionsVendorsKpi.find(vendor => vendor.value === selectedValues.vendor));
		}
		if (selectedValues.sites) {
			const T_5G_Sites: Array<IKPISite>
				= selectedValues.sites.filter(site => site.technology === ETechnologiesValues.T_5G);

			if (T_5G_Sites.length) {
				const checkedValuesT_5G = prepareOptionSiteValues({
					options: options5G,
					sitesByTechnology: T_5G_Sites,
				});

				onChangeSitesT_5G(checkedValuesT_5G, isUpdateDirty);
			} else {
				resetT_5G();
			}
		}
	}, [onChangeSitesT_5G, options5GOran, optionsVendorsKpi, resetT_5G, setValue, vendor?.value]);

	return { resetSitesAndVendor };
};
